import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { SourceBookingsBase } from './SourceBookings'

import { sourcesBookingsSelector } from 'reduxModules/selectors/BookingSelectors'
import withSorting from 'hoc/withSorting'
import { dataSelector } from 'reduxModules/selectors/ModalSelectors'

const mapStateToProps = createStructuredSelector({
  data: dataSelector,
  sourcesBookings: sourcesBookingsSelector,
})

const enhance = compose(
  connect(mapStateToProps),
  withSorting
)

export const SourceBookings = enhance(SourceBookingsBase)


// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/SourceBookings/index.js